import { getCommunityWhenNotMembers } from '~/entities/container/community/api/communities'
import { type CommunityType, CommunityTypeFedSearch } from '~/entities/container/community/interfaces/community'
import { useCommunitiesStore } from '~/entities/container/community/stores/communities'
import { useConversationsStore } from '~/entities/container/conversation/stores/conversations'
import { SearchService } from '~/entities/user/user/api/search'

import { extractContentByKey } from '~/features-shared/content/api/parser-exalead'

/**
 * API V2 OpenAPI doesn't provide 'community_type' anymore,
 * use subject uri to infer the container type by Store/FedSearch/fetch
 */

// eslint-disable-next-line max-statements, complexity
export async function getContainerTypeBySubjectUri(subjectUri: string): Promise<CommunityType | undefined> {
  if (subjectUri.includes(':rt:'))
    return 'externaldm'

  const storeCommunities = useCommunitiesStore()
  const storeConversations = useConversationsStore()

  // CommunityType: 'dm'|'externaldm'
  // CommunityType: 'community'|'personalspace

  // 1. Try to get from store if already existed
  const storeConversation = storeConversations.getConversationBySubjectUri(subjectUri)
  if (storeConversation?.community_type)
    return storeConversation?.community_type

  const storeCommunity = storeCommunities.getCommunityByUri(subjectUri)
  if (storeCommunity?.community_type)
    return storeCommunity.community_type

  // 2. If not existed in store, use FedSearch to infer
  const response = (await SearchService.getContentByResource(subjectUri))?.results
  const communityTypeValue = response && extractContentByKey(response, 'ds6w:type')

  if (communityTypeValue) {
    if (communityTypeValue === CommunityTypeFedSearch.DM)
      return 'dm'
    else if (communityTypeValue === CommunityTypeFedSearch.COMMUNITY)
      return 'community'
    else if (communityTypeValue === CommunityTypeFedSearch.PERSONALSPACE)
      return 'personalspace'
  }

  // 3. In case if FedSearch fails, use fetch
  try {
    const communityApiResp = await getCommunityWhenNotMembers(subjectUri)
    if (communityApiResp)
      return communityApiResp.community_type
    return 'community' // fallback to community (use case when tou are not signed or user is not member)
  }
  catch {
    const conversationAPIResponse = await storeConversations.fetchConversation(subjectUri)
    return conversationAPIResponse?.community_type
  }
}
